import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";

export default function WhyMemoire() {
  const { t } = useLang();
  return (
    <section
      id="why"
      data-testid="why-section"
      className="bg-[#DDE7E4] py-24 lg:py-32"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 lg:grid-cols-12 lg:gap-20 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-5"
        >
          <p className="text-[11px] uppercase tracking-[0.3em] text-neutral-600">
            {t.why.overline}
          </p>
          <h2 className="mt-4 font-['Outfit'] text-4xl font-light leading-tight tracking-tight text-neutral-950 sm:text-5xl lg:text-6xl">
            {t.why.title.split(".")[0]}
            <span className="italic font-['Playfair_Display']">.</span>
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-neutral-700 lg:text-lg">
            {t.why.sub}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-x-10 gap-y-12 sm:grid-cols-2 lg:col-span-7">
          {t.why.features.map((f, i) => (
            <motion.div
              key={f.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`why-feature-${i}`}
              className="border-t border-neutral-800/20 pt-5"
            >
              <span className="font-['Playfair_Display'] text-neutral-500">{f.n}</span>
              <h4 className="mt-2 font-['Outfit'] text-xl text-neutral-950 sm:text-2xl">
                {f.t}
              </h4>
              <p className="mt-3 text-sm leading-relaxed text-neutral-700">{f.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
